/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ video: NonNullable<unknown>, bitwarden: NonNullable<unknown> }} Onboarding_Passkeys_ChatInputs */



/**
* | output |
* | --- |
* | "One more thing before we go: secure your account with a passkey - your fingerprint, face or device PIN instead of a password. You can add one later under Sec..." |
*
* @param {Onboarding_Passkeys_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_passkeys_chat = /** @type {((inputs: Onboarding_Passkeys_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Passkeys_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Noch etwas, bevor es losgeht: Sichere dein Konto mit einem Passkey - Fingerabdruck, Gesicht oder Geräte-PIN statt Passwort. Du kannst ihn später unter Sicherheit hinzufügen. [So funktioniert es](${i?.video}) oder nutze einen Passwort-Manager wie [Bitwarden](${i?.bitwarden}).`)
	return /** @type {LocalizedString} */ (`One more thing before we go: secure your account with a passkey - your fingerprint, face or device PIN instead of a password. You can add one later under Security. [Watch how it works](${i?.video}) or use a password manager like [Bitwarden](${i?.bitwarden}).`)
});